import gql from 'graphql-tag';

export default gql`
  mutation markMessagesAsReadMutation($dialog: MongoID!, $messageIds: [MongoID!]!) {
    markMessagesAsReadMutation(dialog: $dialog, messageIds: $messageIds) {
      updatedCount
    }
  }
`;
